// extracted by mini-css-extract-plugin
module.exports = {"verdict":"e_nbb","eyebrow":"e_obb","rating":"e_pbb","plain":"e_qbb","count":"e_rbb","split":"e_sbb","bar":"e_tbb","sub":"e_ubb","row":"e_vbb"};